// extracted by mini-css-extract-plugin
export default {"section":"Motores_section__Jtnae","imgContainer":"Motores_imgContainer__uE0SP","texto":"Motores_texto__6-ogG","filtro":"Motores_filtro__Z7fAV"};